<fm-flyout-panel
  [connectedElement]="trigger?.elementRef.nativeElement"
  connectedSide="bottomLeft"
  connectedDirection="right"
  (panelOpen)="onPanelOpened()"
  (panelClose)="onPanelClosed()"
  [panelWidth]="containerWidth"
>
  <div class="fm-search-light-panel" [class.fm-search-light-panel--search-active]="results && results.length > 0">
    <div *ngIf="!results && !isSearchValid" class="fm-search-light-panel__warning dropdown-menu show">
      <ng-container *ngIf="isStructuredMessage(minCharsMessage); else minCharsPlain">
        <div class="fm-search-light-panel__warning-title">{{ minCharsMessage.title }}</div>
        <div *ngIf="minCharsMessage.body">{{ minCharsMessage.body }}</div>
      </ng-container>
      <ng-template #minCharsPlain>{{ minCharsMessage }}</ng-template>
    </div>

    <div *ngIf="hasError" class="fm-search-light-panel__warning dropdown-menu show">
      <ng-container *ngIf="isStructuredMessage(errorMessage); else errorPlain">
        <div class="fm-search-light-panel__warning-title">{{ errorMessage.title }}</div>
        <div *ngIf="errorMessage.body">{{ errorMessage.body }}</div>
      </ng-container>
      <ng-template #errorPlain>{{ errorMessage }}</ng-template>
    </div>

    <div *ngIf="results">
      <fm-search-light-category-menu
        *ngIf="results.length > 0"
        [categories]="results"
        (categoryResultSelect)="onCategoryResultSelected($event)"
        (menuClose)="onCategoryMenuClosed()"
      >
      </fm-search-light-category-menu>

      <div *ngIf="results.length === 0 && !isLoading && !hasError" class="fm-search-light-panel__warning dropdown-menu show">
        <ng-container *ngIf="isStructuredMessage(noResultMessage); else noResultPlain">
          <div class="fm-search-light-panel__warning-title">{{ noResultMessage.title }}</div>
          <div *ngIf="noResultMessage.body">{{ noResultMessage.body }}</div>
        </ng-container>
        <ng-template #noResultPlain>{{ noResultMessage }}</ng-template>
      </div>
    </div>
  </div>
</fm-flyout-panel>
